import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import * as commonFunc from 'scripts/common';

import {
    Row, Label,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
} from "reactstrap";
import CGridstack from 'components/CGridstack';

export default function HeaderFrag(props) {
    const { data, modelFctManager, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [collapsed, setCollapsed] = React.useState((data.collapsable && data.defaultCollapsed) || false);
    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if(!data.isLoaded) data.groups = data.groups.filter((group) => !group.temporary);
    }, [data]);


    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        //if ((!data.groups || data.groups.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);

    //useEffect sur props pour trigger APRES le render du composant
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getChilds = () => { return data.groups; };
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = (forceChild) => {
        setShouldRender(!shouldRender);
        if (forceChild) {
            data.groups.forEach((child) => {
                child?.functionManager?.rerender(true);
            });
        }
    };
    data.functionManager.getParent = () => {
        return parentProps.parentData;
    };
    data.functionManager.triggerChange = () => {
        return new Promise((resolve, reject) => {

            if (data.onActionEvents && data.onActionEvents["onChange"]) {
                data.onActionEvents["onChange"].forEach((args, index) => {
                    modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }

            resolve({ isSuccess: true, result: 0 });
        });
    };

    var childs = [];
    var icons = [];
    if (data.groups) {
        data.groups = data.groups.filter(child => !child.isCloned);
        childs = data.groups.map((child) => {
            var childRender = modelFctManager.componentTyped(child, { parentData: data, childs: data.groups, parentDisabled: (parentDisabled || data.disabled ? true : false) });

            if (isConfiguration && !child.gridWidth) {
                var design = child.mergedDesign || child.customDesign?.design;
                var wSize = 1;
                if (design) {
                    wSize = design.boxSize || 1;
                }
                child.gridWidth = Math.round(parseFloat(wSize) * 12);
            }
            if (child.renderLink === "header" || child.groupSubName === "header") {
                icons.push(childRender);
            }
            else if (!isConfiguration || child.groupSubName !== "system") {
                return childRender;
            }
            return "";
        }).filter(item => item !== undefined);
    }

    modelFctManager.applyChildsClone(data, childs, parentDisabled);

    data.childCount = childs.length;

    var icon = "";

    function renderTitle(titleWidthClass, titleWidthStyle) {
        var design = data.customDesign ? data.customDesign.designTitle : null;
        if (!design) design = {}
        var position = design.position;
        if (!position) position = "left";

        var titleModel = <div className={`${titleWidthClass} ${isConfiguration ? "mt-2" : ""} ${data.childless ? "d-none" : ""} ${design?.fontColor ? ("headerTitleFontColor" + design.fontColor.replace(/[^a-zA-Z0-9]/g, '')) : ""}`} style={titleWidthStyle} data-backimage={titleWidthStyle.hasImage || null} data-imageopacity={titleWidthStyle.alpha || null}>
            {design.icon ? <i className="fa fa-user ms-2" style={{ minWidth: "25px" }}></i> : ""}
            {icon}
            <Label className={`m-0 ms-2`}>{altT(data.title)}</Label>
            {data.collapsable ? (collapsed ? <i className="fa fa-chevron-right float-end me-2 mt-1"></i> : <i className="fa fa-chevron-down float-end me-2 mt-1"></i>) : ""}
        </div>;

        if (!commonFunc.isBlank(data.title)) return titleModel;
        else return "";
    }


    var frameClass = "w-100";
    var childStyle = {};
    var childClass = "";
    var frameStyle = { minHeight: "50px", flex: "auto" };
    var frameHiddenAlt = false;//TEMP
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var titleWidthClass = (isConfiguration ? "px-0 " : "");
    var titleWidthStyle = { color: "rgb(37, 36, 34)" };
    var iconStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_header");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass = frameClass.replace("w-100", "");
            frameClass += modelFctManager.manageBoxSize("header-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }
        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        //TEMP
        if (design.backColor === "transparent") {
            frameStyle.background = "transparent";
            frameStyle.border = "0";
            frameStyle.boxShadow = "none";
            if (commonFunc.isBlank(data.title)) {
                frameHiddenAlt = true;
            }
        }
        Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));

        if (design.elevation) {
            frameStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
        }


        if (design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) frameStyle.width = design.width;
            else {
                frameClass += " w-100";
            }
            frameStyle.overflowX = "hidden";//auto
            //frameClass += " m-0";
        }
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) frameStyle.height = design.height;
            else {
                frameClass += " h-100";
                childClass += " h-100";
            }
            frameStyle.overflowY = "hidden";//auto
            //frameClass += " m-0";
        }
    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_headerTitle", true);
    if (designTitle) {
        Object.assign(titleWidthStyle, modelFctManager.setCustomBackground(designTitle, data));
        Object.assign(titleWidthStyle, modelFctManager.managePadding(designTitle, titleWidthClass));
        Object.assign(titleWidthStyle, modelFctManager.manageMargin(designTitle, titleWidthClass));

        if (designTitle.elevation) {
            titleWidthStyle.boxShadow = designTitle.elevation + " " + designTitle.elevation + " 5px rgba(0,0,0,.15)";
        }

        if (designTitle.size || designTitle.width) titleWidthStyle.width = (designTitle.size ? (designTitle.size + "px") : designTitle.width);
        if (designTitle.height) titleWidthStyle.height = designTitle.height;

        if (designTitle.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleWidthStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (designTitle.alignment) {
            var split = designTitle.alignment.split("|");
            split.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
    }
    var designIcon = data.customDesign?.designIcon;
    designIcon = modelFctManager.prepareMergedDesign(data, designIcon, "default_headerIcon", true);
    if (designIcon) {
        Object.assign(iconStyle, modelFctManager.setCustomBackground(designIcon, data));
        Object.assign(iconStyle, modelFctManager.managePadding(designIcon, titleWidthClass));
        Object.assign(iconStyle, modelFctManager.manageMargin(designIcon, titleWidthClass));

        if (designIcon.fontColor) iconStyle.color = modelFctManager.getRgbaFromHex(designIcon.fontColor);
        if (designIcon.fontSize) iconStyle.fontSize = designIcon.fontSize;
        if (designIcon.fontStyle) {
            if (designIcon.fontStyle.indexOf("bold") >= 0) iconStyle.fontWeight = "bold";
            if (designIcon.fontStyle.indexOf("italic") >= 0) iconStyle.fontStyle = "italic";
        }

        if (designIcon.icon) icon = <i className={`fa ${designIcon.icon.replace(/_/g, "-")} me-2`} style={iconStyle} data-backimage={iconStyle.hasImage || null} data-imageopacity={iconStyle.alpha || null}></i>;
    }

    //TODO : errorSystem
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_headerInput", true);
    if (designInput) {
        Object.assign(childStyle, modelFctManager.managePadding(designInput, childClass));
    }

    data.isLoaded = true;

    if (isConfiguration && !data.gridID) data.gridID = Math.floor(Math.random() * 1000000000);

    var styleComp = <style>
        {`
           ${
            (designTitle?.fontColor ? `.headerTitleFontColor${designTitle.fontColor.replace(/[^a-zA-Z0-9]/g, '')} h6 {
              color: ${titleWidthStyle.color} !important;
            }` : "")
            }
        `}
    </style>;


    return (isConfiguration ? <div data-name="HeaderFrag" data-element={data.objType} className={`${frameClass} p-0 px-2`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>
        {styleComp}
        {renderTitle(titleWidthClass, titleWidthStyle)}
        <CGridstack data={childs.map((child, index) => {
            var width = 12;
            var item;
            if (data.groups) {
                //var item = data.groups[index];
                var filteredItems = data.groups.filter(item => item.key == child.key);
                if (filteredItems && filteredItems.length) item = filteredItems[0];
                if (item && item.gridWidth) width = item.gridWidth;
            }
            return { children: child, id: "group-" + data.gridID + "-" + (item?.key || index), srcData: item, noCard: true, x: (index > 0 ? width : 0), y: index * 2, w: width/*, h: 2*/, sizeToContent: true };
        })} type={"header"} srcData={data} configModel={null} isConfigurationMode={true} withRemove={true} noOneColumn={true} defaultState={true} className={`${childClass} ${collapsed ? "d-none" : ""}`} style={childStyle} target={`grid-stack-header-${data.gridID}`} gridClass={`grid-stack-nested`} actionsClass={"text-secondary"} gridOpts={{ resizable: { handles: 's' }, cellHeight: 50, sizeToContent: true, acceptWidgets: ".grid-group, .grid-stack-header > .grid-stack-item" }} triggerClick={(grid, dataItem) => { modelFctManager.setSelected(grid, dataItem); }}
            onDropped={(event, prevNode, n) => {
                modelFctManager.dropManager(data, event, prevNode, n);
                setShouldRender(!shouldRender);
            }} />
    </div>
        : <Card data-name="HeaderFrag" onChange={() => { data.functionManager.triggerChange(); }}
            data-element={data.objType} className={`widget dash ${frameClass}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>
            {styleComp}
            <CardHeader className={`pt-0 ${titleWidthClass} ${data.childless ? "d-none" : ""} ${designTitle?.fontColor ? ("headerTitleFontColor" + designTitle.fontColor.replace(/[^a-zA-Z0-9]/g, '')) : ""}`} style={titleWidthStyle} onClick={() => data.collapsable ? setCollapsed(!collapsed) : ""}>
                {data.collapsable ? (collapsed ? <i className="fa fa-chevron-right float-start me-2 mt-3"></i> : <i className="fa fa-chevron-down float-start me-2 mt-3"></i>) : ""}
                {!commonFunc.isBlank(data.title) ? <CardTitle tag="h6" className="mt-3">{icon}{altT(data.title)}</CardTitle> : ""}
                <div className="widget-tools collapse-tool">
                    {icons.map((i) => i)}
                </div>
                {!frameHiddenAlt ? <div className='borderTheme'></div> : ""}
            </CardHeader>
            <CardBody className={`${data.childless ? (childClass/*.replace("h-100", "")*/) : (childClass.replace("h-100", ""))} ${collapsed ? "d-none" : ""}`} style={childClass.indexOf("h-100") >= 0 ? { flex: "auto", height: (data.childless ? "" : "calc(100% - 70px)") } : {}}>
                <Row className={`m-0 ${childClass}`} style={childStyle}>{childs}</Row>
            </CardBody>
        </Card>);//{renderTitle(titleWidthClass, titleWidthStyle)}
}